import React, { Component } from "react";
import { connect } from "react-redux";
import { Toast } from "antd-mobile/lib";
import Util from "../../util.js";
import {   InvestStop, validateSuperFundUpdate, signSuperFundAccAgreement, getSuperFoundDetail, verifyActivityBoolHaveCast, getSupperFundHome } from "../../action/investmentAction";
import { choseCurrencyIndex, choseCurrentIndex } from "../../action/productAction";
import {  getPayAllSuper,goLogin,hasConvertingTrade } from "../../getPay";
import ModalSelect from "../Modal/ModalSelect";
import { hashHistory } from "react-router";
import NavigatorMain from "../NavigatorMain";
import AlerModle from "./AlerModle";
import { AlerModleCommon, AlerModleQy } from "./AlerModle";
import NHeader from "../NHeader.js";
import "./targetProfitHaveCast.css";
import { LineDataDelAction, lineDataLastDel, userAllIncomeHistoryDel, strategiesDetailsDel, getStrategiesDetailsStopHaveCast, getHistoryIncomeList, getUserTransactionIncomeAndProductIncome, allIncomeLastDel } from "../../action/portfolioAction.js";
import PieEcarts from "../PieEcarts";
import AllIncomeHaveCastLineEcharts from "./AllIncomeHaveCastLineEcharts.js";
import PerformanceTrendsHaveCastLineEcharts from "./PerformanceTrendsHaveCastLineEcharts.js";
import ModalDetail  from "../Modal/ModalDetail";
import { getTempInfo, onMiniProgramDialog } from '../../common.js';
import { GuidePageType } from "../guidePage/index.js";
import Guide from '../guidePage';
import CacheHOC from "../HOC/StateCache.js"

class TargetProfitHaveCast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundIsOpen: "",
      incomeDay: "--",
      dayIncomeDate: "--",
      SharpRate: "",
      Volatility: "",
      resultShow: false,
      alertContent: "",
      updateFlag: true,
      hideFlag: false,
      tabName: "配置概况",
      yearIncomeRate: "",
      ThreeIncome: "",
      singingFlag: false,
      singingFlagNext: false,
      manageFeeRate: "",
      discountRate: "",
      tipFlag: false,
      openState: "",
      endDate: "",
      tsText: [],
      tab: 0,
      dataval: "",
      token: ""
    };
  }
  async componentDidMount() {
    this.props.dispatch(getSupperFundHome({}, () => {}, this));
    const token = await getTempInfo('shortToken');
    this.setState({
      token: token
    });
    document.body.scrollTo(0, 0);
  }
  goHistoryProfit = () => {
    let SupperFundHome = this.props.SupperFundHome;
    let data = SupperFundHome ? (this.props.SupperFundHome.singleSuperFundViews ? this.props.SupperFundHome.singleSuperFundViews : []) : [];
    hashHistory.push({
          pathname: '/HistoryProfit',
          state: {
                SuperList: data,
          },
          query: {
                SuperList: "",
          }
    })
  }
  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "进入"]);
    let { dispatch } = this.props;
    console.log(this.props.location);
    let superFundCode = this.props.location.query.superFundCode ? this.props.location.query.superFundCode : "SF1003";
    let len = Util.superFundCodeArrByTarget.indexOf(superFundCode);
    document.title = Util.superFundCodeArrByTargetName[len]?Util.superFundCodeArrByTargetName[len]:'策略详情';
    let data1 = { superFundCode };
    dispatch(getSuperFoundDetail(superFundCode));
    this.props.dispatch(validateSuperFundUpdate(data1));
    dispatch(
      verifyActivityBoolHaveCast({ superFundCode, stopProfit: true }, (result) => {
        this.setState({
          openState: result.activitySuperFund.state,
          endDate: Util.dateMD(result.activitySuperFund.endDate),
        });
      })
    );
    
    dispatch(
      getStrategiesDetailsStopHaveCast({
        superFundCode: this.props.location.state.superFundCode,
      },(val)=>{this.setState({dataval:val}),console.log(val)})
    );
    dispatch(
      getHistoryIncomeList({
        superFundCode: this.props.location.state.superFundCode,
        periodType: 1,
      })
    );
  }
  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "离开"]);
    Guide.leave();
    document.title = "";
  }
  callBack(data) {}

  goInvesting() {
    window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "追加投资"]);
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    let { history, inNeedNotice, inNeedUpdate, dispatch, SuperFoundDetailXCL ,strategiesDetails} = this.props;
    let route = window.history.length;
    let superFundUserShare = strategiesDetails&&strategiesDetails.superFundUserShare;
    if (inNeedNotice == true) {
    } else if (inNeedUpdate == true) {
    } else {
      let params = {
        fundCode: superFundUserShare&&superFundUserShare.superFundCode,
        fundName: superFundUserShare&&superFundUserShare.superFundName,
        isShowModal: false, //首次购买弹窗标识
        prompt: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].prompt,
        policy: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].policy,
        policyTitle: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].policyTitle,
        productType: "Z",
        pageText: "无定投",
        superTypeValue: "1",
      };
      getPayAllSuper(route, params, hashHistory, "PaymentAllSuperFund");
    }
  }
  RedeemSuperFund(data) {
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    if (!data  && !this.props.InvestStopDetil ) {
      return false;
    }
    if (data.buyFlag != true) {

      let fun = () => {
        Toast.loading();
        hasConvertingTrade({
          superFundCode: this.state.dataval?this.state.dataval.superFundUserShare.superFundCode:"",
        }, () => {
          Toast.hide()
        }, () => {
          Toast.hide()
        })
        .then((suc) =>{
          if(suc === true) {
            Toast.show('当前智投组合有转换在途交易，该操作暂停', Util.ToastTime);
            return;
          }
          this.props.dispatch(choseCurrentIndex(0));
          this.props.dispatch(choseCurrencyIndex(0));

          hashHistory.push({
            pathname: "/RedeemSuperFund",
            state: {
              fundCode: this.state.dataval?this.state.dataval.superFundUserShare.superFundCode:"",
              fundName: this.state.dataval?this.state.dataval.superFundUserShare.superFundName:"",
              cardList: this.state.dataval?this.state.dataval.superFundUserShare.superFundChannelList:"",
              totalAmount: this.state.dataval?this.state.dataval.superFundUserShare.totalAmount:"",
            },
          });
          

        })
        .catch((err) => {
          Toast.hide();
          return;
        });
      };
      goLogin(fun, window.history.length);

      
    } else {
      Toast.info("华夏智投正在调仓、赎回、申购中，无法进行此操作", Util.ToastTime);
    }
  }
  goBack() {
    hashHistory.goBack();
  }
 
  /**同意签约 */
  handleArgee() {
    this.props.dispatch(
      signSuperFundAccAgreement({ state: 1, operator: "user" }, () => {
        this.setState(
          {
            singingFlag: false,
          },
          this.pushUpdate()
        );
      })
    );
  }
  //暂不签约
  handleDisagree() {
    this.setState({
      singingFlag: false,
      singingFlagNext: true,
    });
  }
  /**返回签约页 */
  callBackQy() {
    this.setState({
      singingFlag: true,
      singingFlagNext: false,
    });
  }
  /**不同意签约 */
  closeDisAgreeAlert() {
    this.setState({
      singingFlagNext: false,
    });
  }
  showWenHaoView = (event, val) => {
    event.stopPropagation();
    if (val == "当前资产") {
      this.setState({
        tipFlag: true,
        tsText: ["资产分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品资产，预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品资产。遇特殊情况（分红、折算等）资产可能不准确，分红、折算确认后会自动修复。"],
      });
    } else if (val == "最新收益") {
      this.setState({
        tipFlag: true,
        tsText: ["1. 日收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，日收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的日收益不展示在日收益中。"],
      });
    } else if (val == "累计收益") {
      this.setState({
        tipFlag: true,
        tsText: ["1. 累计收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，累计收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的最新收益展示在累计收益中。"],
      });
    }
  };
  toTartgetProfitDetail = () => {
    let data = this.props.strategiesDetails || {};
    let shareQueryResponse = data.superFundUserShare || {};
    hashHistory.push({
      pathname: "/TargetProfitDetail",
      state: { ...this.props.location.state, superFundName: shareQueryResponse.superFundName },
      query: { ...this.props.location.state, superFundName: shareQueryResponse.superFundName },
    });
  };

  getColor = (value) => {
    if (value === "--") return "#333";
    if (value.replace("%", "") >= 0) return "#F8515C";
    return "#1DA96B";
  };

  getAll = () => {
    hashHistory.push({
      pathname: "/ServiceReport",
      state: { superFundCode: this.props.location.state.superFundCode, hasQuarterly: true, serveDays: this.props.serveDays, token: this.state.token },
      query: { superFundCode: this.props.location.state.superFundCode, hasQuarterly: true, serveDays: this.props.serveDays, token: this.state.token },
    });
  };

  toRecentNewsDetail = (v) => {
    console.log(v);
    if(v.monthReportToPortal && this.state.token) {
      const fundCode = v.monthReportToPortal.monthReportTemplate.fundCode;
      const year = v.monthReportToPortal.monthReportTemplate.year;
      const month = v.monthReportToPortal.monthReportTemplate.month;
      const token = this.state.token;
      const _url = year > 2020 ? "NewQuarterlyReport/index.html?device=h5&token=" : "QuarterlyReport/index.html?device=h5&token="
      const _urlSec = _url + token + "&fundCode=" + fundCode + "&month=" + month + "&year=" +  year;
      // window.open("http://10.16.160.74/monthReport/" + _urlSec); //测试
      window.open("https://app.amcfortune.com/wAppStatic/" + _urlSec); //生产
    }else {
      hashHistory.push({
        pathname: "/ServiceReportDetail",
        state: { id:v.id },
        query: { id:v.id },
      });
    }
  };
  toggerToPrtformanceTrends = () => {
    this.setState({ tab: 1 });
    let { dispatch, location, lineData } = this.props;
    if (lineData[1]) return;
    dispatch(
      getUserTransactionIncomeAndProductIncome({
        superFundCode: this.props.location.state.superFundCode,
        periodType: 1,
      })
    );
  };
  jiaoyimingxi() {
    hashHistory.push({
      pathname: "/Transactionrecordztgz",
      state: {
        superFundCode: this.props.location.state.superFundCode,
      },
    });
  }
  toDetail=()=>{
    hashHistory.push({
      pathname:'/PositionDetailsHavaCast',
      state:{fundItems:this.props.fundItems},
      query:{fundItems:this.props.fundItems}
    })
  }
  render() {
    const { buyFlag, adjustFlag, totalAmount, dayIncome, allIncome, annualizedGains, operationDay, collectingStatus, serveDays, recentNewsList = [], superFundNotifications = [], fundItemsUpdateDate = "--", legendData = [], seriesData = [] } = this.props;

    let superFundCode = this.props.location.query.superFundCode;
    let ua = navigator.userAgent.toLowerCase();
    console.log(ua.match(/MicroMessenger/i) == "micromessenger");
    // let { tabName } = this.state;
    // let { dispatch, inNeedNotice, SuperFoundDetailXCL } = this.props;
    let data = this.props.strategiesDetails || {};
    //let flag_pie = data ? data.shareQueryResponse.fundItems : false;

    // document.getElementsByTagName('title')[0].innerHTML = data ? data.productQueryResponse.superFundName : "";
    let shareQueryResponse = data.superFundUserShare || {};
    //let performance = data ? Util.fomatFloat(data.productQueryResponse.performance * 100) : "";
    //let maxRetracement = data ? Util.fomatFloat(data.productQueryResponse.maxRetracement * 100) : "";

    let Amount=Util.parsePrice(shareQueryResponse.totalAmount)
    const collectingObj = {
      0: "募集中",
      1: "募集结束",
      2: Util.toPercent(annualizedGains),
    };
    return (
      <div className="container">
        <ModalSelect />
        <NavigatorMain>
          <NHeader
            title={shareQueryResponse.superFundName}
            rightContent={
              <div className="style_md_white_font" onClick={this.toTartgetProfitDetail.bind(this)}>
                策略详情
              </div>
            }
            isPaddingBottom={0}
          />
        </NavigatorMain>
        <div className="content paddB40" id="TargetProfitHaveCastIndex" style={{ paddingTop: 0,display:'flex',flex:1,overflowY:'scroll',flexDirection:'column' }}>
          {/* 基本信息 */}
          <div className="style_md_white_font style_transparent_color target_content_bg">
            {/* 总资产 */}
            <div className="style_flex_column_center target_total_amount">
              <div className="tartget_total_amount_tit">
                <span style={{ marginRight: ".1rem" }}>总资产</span>
                <img
                  onClick={(event) => {
                    this.showWenHaoView(event, "当前资产");
                  }}
                  style={{ width: ".24rem" }}
                  src={require("../../img/n_icon_shuoming.png")}
                />
              </div>
              <div className="total_amount_font">{Amount}</div>
            </div>
            {/* 基本信息 */}
            <div className="style_flex_row_center target_info">
              <div className="style_flex_average style_center_align">
                <div style={{ marginBottom: ".06rem" }}>最新收益 (元)</div>
                <div className="style_lbg_font style_font_weight">{Util.processingDecimal(dayIncome,2,true)}</div>
              </div>
              <div className="style_flex_average style_center_align">
                <div style={{ marginBottom: ".06rem" }}>累计收益 (元)</div>
                <div className="style_lbg_font style_font_weight">{Util.processingDecimal(allIncome,2,true)}</div>
              </div>
              <div className="style_flex_average style_center_align style_flex_column_center">
                <div className="style_flex_column_center operationDay">
                  <div style={{ color: "#FFE5B9" }}>{collectingStatus !== undefined ? collectingStatus === 2 ? `已运作${operationDay}天` : "未开始运作" : <span style={{ color: "#fff" }}>--</span>}</div>
                </div>
                <div style={{ marginBottom: ".06rem", marginTop: ".1rem" }}>运作以来年化</div>
                <div className="style_lbg_font style_font_weight">{collectingStatus !== undefined ? collectingObj[collectingStatus] : "--"}</div>
              </div>
            </div>
            {/* 消息提醒 */}
            {superFundNotifications && !!superFundNotifications.length && (
              <div className="style_sm_font style_color_light  target_notification">
                {superFundNotifications.map((v, i) => {
                  if (v.transactionType == 0)
                    return (
                      <div className="target_notification_item">
                        您有{v.transactionNum}笔转入<span className="style_color_dark">{Util.processingDecimal(v.amount,2) || "--"}</span>元{v.confirmStatus?'确认中':'待确认'}，预计{`${new Date(v.date).getMonth() + 1}.${new Date(v.date).getDate()}`}可查看收益
                      </div>
                    );
                  if (v.transactionType == 1)
                    return (
                      <div className="target_notification_item">
                        您有{v.transactionNum}笔转出交易{v.confirmStatus?'，成分基金将陆续确认。':'待确认，'}预计<span className="style_color_dark">{`${new Date(v.date).getMonth() + 1}.${new Date(v.date).getDate()}`}</span>资金到账
                      </div>
                    );
                  if (v.transactionType == 2)
                    return v.notifications.map((value, i) => (
                      <div className="target_notification_item">
                        调仓进行中，当前资产为预估资产，调仓结束后展示实际资产。预计<span className="style_color_dark">{`${new Date(value.date).getMonth() + 1}.${new Date(value.date).getDate()}`}调仓结束</span>
                      </div>
                    ));
                  if (v.transactionType == 3)
                    return v.notifications.map((value, i) => (
                      <div className="target_notification_item">
                        预计{v.fundName}（{value.fundCode}）在<span className="style_color_dark">{`${new Date(value.date).getMonth() + 1}-${new Date(value.date).getDate()}`}</span>有分红，届时资产和收益不准确，分红折算确认后会自动修复
                      </div>
                    ));
                })}
              </div>
            )}
            {/* 最新动态 */}
            {recentNewsList && !!recentNewsList.length && (
              <div className="tartget_news_list" >
                <div className="style_flex_row_center target_serve_day_wrap" onClick={this.getAll}>
                  <div className="tartget_serve_day">
                    Hi，已为您服务<span style={{ color: "#B69271" }}>{serveDays || "--"}</span>天
                  </div>
                  <img style={{ width: ".2rem" }} src={require("../../img/n_icon_arrow_gray.png")} />
                </div>

                <div className="style_flex_row_center target_info_list">
                  <div className="style_flex_row_center" style={{ marginRight: ".3rem", justifyContent: "flex-start" }}>
                    {recentNewsList.map((v, i) => (
                      <div key={i} className="tartget_news_item" onClick={()=>this.toRecentNewsDetail(v)}>
                        <div className="style_font_weight style_overflow_ellipsis" style={{ marginBottom: ".1rem" }}>
                          {v.title}
                        </div>
                        <div className="style_sm_font" style={{ color: "#875426" }}>
                          {v.newsTime}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            
          </div>
          {/* 收益明细、交易明细入口 */}
          <div className="style_flex_row_center target_mingxi">
              <div className="style_flex_average style_flex_row_center" onClick={this.goHistoryProfit}>
                <img style={{ width: ".64rem", marginRight: ".1rem" }} src={require("../../img/n_icon_shouyimingxi.png")} />
                <span className="style_md_white_font style_color_dark">收益明细</span>
              </div>
              <div className="style_flex_average style_flex_row_center" onClick={() => this.jiaoyimingxi()}>
                <img style={{ width: ".64rem", marginRight: ".1rem" }} src={require("../../img/n_icon_jiaoyimingxi.png")} />
                <span className="style_md_white_font style_color_dark">交易明细</span>
              </div>
            </div>
          {/* 折线图 */}
          <div style={{ padding: " .4rem", background: "#fff", marginBottom: ".2rem" }}>
            <div className="style_md_white_font style_color_neutral line_echarts_btn" style={{ marginBottom: ".3rem" }}>
              <span
                onClick={() => {
                  this.setState({ tab: 0 });
                }}
                className={`style_flex_column_center ${this.state.tab == 0 && "style_bg_font style_color_dark style_font_weight tab_underline"}`}
              >
                累计盈亏
              </span>
              <span onClick={this.toggerToPrtformanceTrends.bind(this)} className={`style_flex_column_center ${this.state.tab == 1 && "style_bg_font style_color_dark style_font_weight tab_underline"}`}>
                业绩走势
              </span>
            </div>
            <div>
              {this.state.tab == 0 && <AllIncomeHaveCastLineEcharts />}
              {this.state.tab == 1 && <PerformanceTrendsHaveCastLineEcharts />}
            </div>
          </div>
          {/* 饼图 */}
          <div className="target_pie_echarts">
            <div className="style_flex_row_between">
              <span className="style_bg_font style_color_dark style_font_weight">我的持仓</span>
              <span className="style_md_white_font style_color_light">持仓数据仅含可用份额，不含冻结份额</span>
            </div>
            {
                legendData.length > 0 ?
                <PieEcarts height="2.8rem" legendData={legendData} seriesData={seriesData} />
                :
                <div style={{display:"flex",flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".4rem",paddingBottom:".4rem"}}>
                    <img style={{width:"4.14rem",height:"2.52rem"}}  src={require("../../imgs/iconkongkongruye.png")}/>
                    <text style={{fontSize:".28rem",lineHeight:".4rem"}}>这里空空如也～</text>
                </div>
              }
               {
                legendData.length > 0 ?
                <div className="style_sm_font style_center_align target_detail" onClick={this.toDetail}>
                查看详细持仓
                <img style={{ width: ".2rem" }} src={require("../../img/n_icon_right_arrow.png")} />
              </div>
              :
              null
               }
          </div>
          {/* 客服 */}
          <div className="style_sm_font style_flex_row_center target_kefu">
            <a href="tel:4008175666" className="style_sm_font style_flex_row_center" style={{ flex: 1, justifyContent: "space-between" }}>
              <span className="style_flex_row_center ">
                <img style={{ width: ".48rem", marginRight: ".16rem" }} src={require("../../img/n_icon_kefu.png")} />
                智能客服
              </span>
              <img style={{ width: ".2rem" }} src={require("../../img/n_icon_arrow_gray.png")} />
            </a>
          </div>
          {/* 风险提示 */}
          <div className="style_sm_font style_color_light target_tip">
            风险提示<span>：</span>市场有风险，投资需谨慎。本公司承诺以诚实信用、勤勉尽责的原则提供基金投资顾问服务，提供投资建议并为投资者调仓，但不保证投顾账户一定盈利，也不保证最低收益。组合历史业绩不代表未来收益。本公司提醒投资者接受基金投资顾问服务遵循“买者自负”原则，投资者应结合自身的投资经历、风险承受能力、资产配置需要作出投资决策，投顾账户的投资风险由投资者自行承担。为其他客户创造的收益，并不构成业绩表现的保证。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。投资者应自行阅读《上海华夏财富投资管理有限公司基金投资顾问服务协议》《风险揭示书》《组合策略说明书》等产品法律文件，自行做出投资选择。基金投顾组合及基金投资遵循“买者自负”原则，投资者应自行承担投资风险。
          </div>
        </div>

        {this.state.openState === "已开始" ? (
          <div className="style_bg_font style_flex_row_center style_center_align FixedBottomHave" style={{ height: ".96rem", lineHeight: ".96rem", background: "#fff" }}>
            <div className="style_flex_average" style={{ color: "#B69271", background: "#fff", height: "100%",border:'1px solid #F3F3F3' }} onClick={() => this.RedeemSuperFund(shareQueryResponse)}>
              {/* 赎回 */}转出
            </div>
            <div className="style_flex_average" style={{ color: "#fff", background: "#BF9B79", height: "100%" }} onClick={() => this.goInvesting(shareQueryResponse)}>
              {/* 追加 */}转入
            </div>
          </div>
        ) : (
          <div className="style_bg_font style_flex_row_center style_center_align FixedBottomHave" style={{ height: ".96rem", lineHeight: ".96rem", background: "#fff" }}>
            <div className="style_flex_average" style={{ color: "#B69271", background: "#fff", height: "100%",border:'1px solid #F3F3F3' }} onClick={() => this.RedeemSuperFund(shareQueryResponse)}>
              {/* 赎回 */}转出
            </div>
          </div>
        )}

        {this.state.resultShow ? (
          <AlerModle
            content={this.state.alertContent}
            CloseAler={() => {
              this.setState({ resultShow: false });
            }}
          />
        ) : null}
        {this.state.singingFlag ? <AlerModleQy handleClick1={this.handleArgee.bind(this)} handleClick2={this.handleDisagree.bind(this)} /> : null}
        {this.state.singingFlagNext ? <AlerModleCommon btnTxt1="返回签约页面" btnTxt2="知道了，暂不签约" content={"根据监管要求，只能对签约的客户提供基金投顾服务。如未及时签约，华夏财富将无法再为您提供自动调仓等服务，您可选择继续持有当前份额或赎回。"} title="签约提醒" handleClick1={this.callBackQy.bind(this)} handleClick2={this.closeDisAgreeAlert.bind(this)} /> : null}
        <ModalDetail
          flag={this.state.tipFlag}
          rightButtonTitle="知道了"
          content={this.state.tsText}
          onOK={() => {
            this.setState({ tipFlag: false });
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let { superFundUserShare = {}, recentNewsList = [], stopProfitOperationInfo = {}, superFundNotifications = [] } = state.strategiesDetails;
  stopProfitOperationInfo=stopProfitOperationInfo||{}
  return {
    strategiesDetails: state.strategiesDetails,
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    inNeedNotice: state.inNeedNotice,
    // payLoading:state.riskInPay.payLoading,
    // InvestStopDetil: state.InvestStopDetil,
    validateSuperFundUpdateData: state.validateSuperFundUpdate,
    superFundAccAgreementState: state.superFundAccAgreementState,
    SuperFoundDetailXCL: state.SuperFoundDetailXCL,

    totalAmount: superFundUserShare.totalAmount,
    dayIncome: superFundUserShare.dayIncome,
    allIncome: superFundUserShare.allIncome,
    annualizedGains: stopProfitOperationInfo.annualizedGains,
    recentNewsList,
    superFundNotifications,
    serveDays: superFundUserShare.serveDays,
    operationDay: stopProfitOperationInfo.operationDay,
    collectingStatus: stopProfitOperationInfo.collectingStatus,
    legendData: superFundUserShare.legendData,
    seriesData: superFundUserShare.seriesData,
    fundItemsUpdateDate: superFundUserShare.fundItemsUpdateDate,
    lineData: state.lineData,
    userAllIncomeHistory: state.userAllIncomeHistory,
    adjustFlag: superFundUserShare.adjustFlag,
    buyFlag: superFundUserShare.buyFlag,
    fundItems:superFundUserShare.fundItems,
    SupperFundHome: state.SupperFundHome,
  };
}

export default connect(mapStateToProps)(CacheHOC(TargetProfitHaveCast,'TargetProfitHaveCastIndex'));

function add0(m) {
  return m < 10 ? "0" + m : m;
}
function formatTime(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  let time = new Date(shijianchuo);
  let y = time.getFullYear();
  let m = time.getMonth() + 1;
  let d = time.getDate();
  // let h = time.getHours();
  // let mm = time.getMinutes();
  // let s = time.getSeconds();
  return y + "." + add0(m) + "." + add0(d);
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/TargetProfitHaveCast.js